import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { VueTranslationService } from '@vue/vueframework';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccountServicesBundleResolve {
  public constructor(private vueTranslationService: VueTranslationService) {}

  public resolve(ignored: ActivatedRouteSnapshot): Observable<Record<string, string>> {
    return this.vueTranslationService.getTranslationBundle('AccountServices', null);
  }
}
